const STORAGE_KEY = "unzippd_seen_enquiries_v1";
export const SEEN_ENQUIRIES_UPDATED_EVENT = "seen-enquiries-updated";

const ENQUIRY_TYPES = ["contacts", "demos", "support"];

const readStore = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeStore = (store) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    window.dispatchEvent(new Event(SEEN_ENQUIRIES_UPDATED_EVENT));
  } catch {
    // ignore storage failures
  }
};

const getUserKey = (userId) => String(userId || "anonymous");

export const getSeenEnquiryIds = (userId, type) => {
  const store = readStore();
  const userStore = store[getUserKey(userId)] || {};
  return new Set(userStore[type] || []);
};

export const markEnquiriesAsSeen = (userId, type, ids = []) => {
  if (!ENQUIRY_TYPES.includes(type)) return;

  const normalizedIds = [
    ...new Set(ids.map((id) => String(id)).filter(Boolean)),
  ];
  if (!normalizedIds.length) return;

  const store = readStore();
  const userKey = getUserKey(userId);
  const userStore = store[userKey] || {};
  const existing = new Set(userStore[type] || []);
  let changed = false;

  normalizedIds.forEach((id) => {
    if (!existing.has(id)) {
      existing.add(id);
      changed = true;
    }
  });

  if (!changed) return;

  writeStore({
    ...store,
    [userKey]: {
      ...userStore,
      [type]: [...existing],
    },
  });
};

const isUnreadFromApi = (item) => {
  if (!item) return null;

  const rules = [
    {
      fields: ["is_read", "is_seen", "seen", "viewed"],
      value: false,
      result: true,
    },
    { fields: ["is_new"], value: true, result: true },
    {
      fields: ["is_read", "is_seen", "seen", "viewed"],
      value: true,
      result: false,
    },
  ];

  for (const { fields, value, result } of rules) {
    if (fields.some((field) => item[field] === value)) {
      return result;
    }
  }

  return null;
};

export const isUnseenEnquiry = (item, seenIds) => {
  const apiUnread = isUnreadFromApi(item);
  if (apiUnread !== null) return apiUnread;

  const id = String(item?._id || item?.id || "");
  if (!id) return false;

  return !seenIds.has(id);
};
